import { SVGProps } from "react";

const AssignedAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0103 6.47998C13.8932 6.48012 15.4407 7.96851 15.5356 9.82861L15.5396 10.0103C15.5295 11.9318 14.0326 13.4683 12.1343 13.5298H11.9653C9.96088 13.4679 8.48012 11.9154 8.47998 10.0103C8.47998 8.0664 10.0664 6.47998 12.0103 6.47998ZM11.9995 6.97021C10.3225 6.97047 8.97047 8.33502 8.97021 9.99951C8.97021 11.6373 10.2515 12.9697 11.8813 13.0298L11.9722 13.0327L12.0005 13.0229C12.0091 13.0231 12.0189 13.0234 12.0298 13.0239L12.0806 13.0278L12.1177 13.0317L12.1558 13.0298C13.6622 12.9511 14.8595 11.7857 15.0132 10.3042L15.0298 10.0034V9.99951C15.0295 8.33487 13.6768 6.97021 11.9995 6.97021Z"
      fill="#3A3A3B"
      stroke="currentColor"
    />
    <path
      d="M12.0042 15.6951C13.8788 15.6951 15.7265 16.1724 17.1125 17.0964V17.0955C18.18 17.8164 18.8017 18.7237 18.9661 19.6658L18.9934 19.8542L18.9944 19.8621C19.0011 19.916 18.9884 19.968 18.9563 20.0134L18.9182 20.0564L18.9124 20.0613C17.0143 21.7971 14.5648 22.7497 12.0002 22.7498C9.59584 22.7498 7.29202 21.9128 5.44946 20.3777L5.08716 20.0613L5.08228 20.0564L5.04907 20.0183C5.02014 19.9748 5.0028 19.9146 5.00806 19.8464C5.11388 18.9013 5.67687 17.9753 6.67993 17.241L6.88696 17.0964C8.27843 16.172 10.1295 15.6951 12.0042 15.6951ZM12.0022 16.1902C10.3778 16.1902 8.72508 16.565 7.42017 17.3425L7.16431 17.5027L7.1604 17.5056C6.38354 18.0308 5.82245 18.7077 5.60083 19.4587L5.50806 19.7732L5.75903 19.9832C7.50907 21.4485 9.71293 22.2498 12.0002 22.2498C14.2875 22.2497 16.4915 21.4485 18.2415 19.9832L18.4924 19.7732L18.3997 19.4587C18.2049 18.7989 17.7415 18.1986 17.1106 17.7087L16.8303 17.5056L16.8274 17.5037L16.5725 17.3425C15.2756 16.5644 13.6262 16.1902 12.0022 16.1902Z"
      fill="#3A3A3B"
      stroke="currentColor"
    />
    <path
      d="M12 2.25C17.6539 2.25 22.25 6.84614 22.25 12.5C22.25 18.1539 17.6539 22.75 12 22.75C6.34614 22.75 1.75 18.1539 1.75 12.5C1.75 6.84614 6.34614 2.25 12 2.25ZM12 2.75C6.62386 2.75 2.25 7.12386 2.25 12.5C2.25 17.8761 6.62386 22.25 12 22.25C17.3761 22.25 21.75 17.8761 21.75 12.5C21.75 7.12386 17.3761 2.75 12 2.75Z"
      fill="#3A3A3B"
      stroke="currentColor"
    />
  </svg>
);
export default AssignedAccount;
